<template>
  <!-- eslint-disable vue/require-component-is -->
  <component v-bind="linkProps(to)">
    <slot />
  </component>
</template>

<script>
import { isExternal } from '@/utils/validate'

export default {
  props: {
    to: {
      type: String,
      required: true
    }
  },
  methods: {
    linkProps(url) {
      let props;
      if (url === '/largeScreen') {
        const baseUrl = window.location.origin;
        return {
          is: 'a',
          href: `${baseUrl}/#${url}`, // 使用绝对路径拼接
          target: '_blank',
          rel: 'noopener'
        };
      } else if (isExternal(url)) {
        props = {
          is: 'a',
          href: url,
          target: '_blank',
          rel: 'noopener'
        };
      } else {
        props = {
          is: 'router-link',
          to: url
        };
      }
      return props;
    }
  }
}
</script>